import css from 'styled-jsx/css';

export default css`
  .relatedResultsnoResults {
    margin-bottom: 10px;
    padding: 10px;
    background-color: #fcfce3;
    border-radius: 5px;
  }

  .oldResultsElement {
    padding-bottom: 10px;
    margin: 0;
  }

  .newResultsElement {
    margin: 0;
  }

  .oldResultsElement strong {
    font-weight: 100;
  }
`;



// WEBPACK FOOTER //
// ./app/Serp/components/DidYouMeanBanner/styles.js